
import React from "react";
import RaceInfoHeader from "../common/RaceInfoHeader";
import RaceCard from "./RaceCard";
// import "./RaceCards.scss";


const RaceLeagueBox = ({ league, sport, dataClient, dataPath, websiteBaseUrl }) => {
  const { races = [], cnm, go, dt, nor, co, wea, } = league;

  return (
    <>
      <RaceInfoHeader
        courseName={cnm}
        country={co}
        date={dt}
        numberOfRaces={nor}
      />
      <RaceCard races={races} weather={wea} going={go} cnm={cnm} dt={dt} sport={sport} dataClient={dataClient} dataPath={dataPath} websiteBaseUrl={websiteBaseUrl} />
    </>

  );
};

export default RaceLeagueBox;
